import { userActions } from "../../actionTypes";

const initialState = {
	code: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case userActions.SEND_FACEBOOK_TOKEN_FETCHING: {
			return { ...state, fetching: true };
		}

		case userActions.SEND_FACEBOOK_TOKEN_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				code: action.payload,
			};
		}

		case userActions.SEND_FACEBOOK_TOKEN_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
			return state;
	}
};

export default Reducer;
